import { render, staticRenderFns } from "./addNoval.vue?vue&type=template&id=79b2ed89&scoped=true"
import script from "./addNoval.vue?vue&type=script&lang=js"
export * from "./addNoval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b2ed89",
  null
  
)

export default component.exports